
// Remove diacritics from Vietnamese (and other Latin letters). Also map đ/Đ to d/D.
const removeDiacritics = (s: string) => {
    try {
        return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D');
    } catch (err) {
        // fallback: simple replace for common Vietnamese letters
        return s.replace(/đ/g, 'd').replace(/Đ/g, 'D');
    }
};

// Allow printable ASCII and Latin-based letters (covers Vietnamese precomposed chars).
const sanitizeInput = (s: string) => {
    // Keep: printable ASCII (0x20-0x7E), Latin-1/Extended and Latin Extended Additional ranges and combining marks
    return s.replace(/[^\x20-\x7E\u00C0-\u024F\u1E00-\u1EFF\u0300-\u036F]/g, '').replace(/\uFE0F/g, '');
};
export { removeDiacritics, sanitizeInput };